import React from 'react'
import './../styles/Footer.css'

function Footer() {
  return (
    <footer>
      <p>By <a href="https://westbrookdaniel.com/">Daniel Westbrook</a></p>
    </footer>
  )
}

export default Footer
